import Storage from './storage'
import { getCurrentUser } from '../services/userProfile'

export function getUser(useLocalStorage = true) {
  let currentUser = null
  if (useLocalStorage) {
    currentUser = Storage.getEncoded('currentUser', false)
  }
  if (!currentUser) {
    currentUser = getCurrentUser()
      .then(response => {
        if (response.success) {
          return response.data
        } else {
          console.error('USER ACCESS FAILURE', response.data)
        }
      })
      .catch(err => {
        console.error('USER ACCESS FAILURE', err)
      })
  }
  return currentUser
}

export function shouldForceUserRefresh() {
  const { tokens = {} } = getUser()
  return Math.floor(Date.now() / 1000) >= tokens.identity?.exp
}
